import type { TopUpStatus, WalletTxnType } from "@/types/wallet";

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const RANGES = ["Today", "Last 7 Days", "Last 30 Days", "This Month", "Last 3 Months"];

export const DEFAULT_RANGE = "Last 30 Days";

export function formatINR(n?: number | string | null): string {
  const num = Number(n);
  const safeNum = Number.isFinite(num) ? num : 0;
  return `\u20B9${safeNum.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
}

export function formatTime(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });
}

export interface TypeMeta {
  label: string;
  text: string;
  bg: string;
}

export const TXN_TYPE_META: Record<WalletTxnType, TypeMeta> = {
  CREDIT: { label: "Credit", text: "text-emerald-700", bg: "bg-success-bg" },
  DEBIT: { label: "Debit", text: "text-red-700", bg: "bg-danger-bg" },
  ADJUSTMENT: { label: "Adjustment", text: "text-slate-600", bg: "bg-badgeSlate-bg" },
};

export const TOPUP_STATUS_META: Record<TopUpStatus, TypeMeta> = {
  PENDING: { label: "Pending", text: "text-amber-700", bg: "bg-warning-bg" },
  APPROVED: { label: "Approved", text: "text-emerald-700", bg: "bg-success-bg" },
  REJECTED: { label: "Rejected", text: "text-red-700", bg: "bg-danger-bg" },
};

export const TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "All Types" },
  { value: "CREDIT", label: "Credit" },
  { value: "DEBIT", label: "Debit" },
  { value: "ADJUSTMENT", label: "Adjustment" },
];

export function inRange(createdAt: string, range: string, customFrom: string, customTo: string): boolean {
  const d = new Date(createdAt);
  const now = new Date();
  switch (range) {
    case "Today":
      return d.toDateString() === now.toDateString();
    case "Last 7 Days":
      return d.getTime() >= now.getTime() - 7 * 86400000;
    case "Last 30 Days":
      return d.getTime() >= now.getTime() - 30 * 86400000;
    case "This Month":
      return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    case "Last 3 Months":
      return d.getTime() >= now.getTime() - 3 * 30 * 86400000;
    case "Custom Range": {
      if (customFrom) {
        const f = new Date(customFrom);
        if (d.getTime() < f.getTime()) return false;
      }
      if (customTo) {
        const t = new Date(customTo);
        t.setDate(t.getDate() + 1);
        if (d.getTime() >= t.getTime()) return false;
      }
      return true;
    }
    default:
      return true;
  }
}

export function isPositiveTxn(type: WalletTxnType): boolean {
  return type === "CREDIT";
}